module.exports = __webpack_public_path__ + "static/img/健康普查.12147fce.jpg";